export default __webpack_public_path__ + "media/600af2ada14dcba129b54de83edaada47cfd94f82d27f7c740ca18b665dcff4a.svg";